import DeviceConfirm from './DeviceConfirm';

export default DeviceConfirm;
